/* eslint-disable max-len */
export const getCookie = (name) => {
  if (typeof document === 'undefined') return null;

  const re = new RegExp(`${name}=([^;]+)`);
  const value = re.exec(document.cookie);

  return (value != null) ? unescape(value[1]) : null;
};
/* eslint-enable max-len */

/**
 * Write a host cookie (Path=/) shared across the domain.
 * @param {string} name
 * @param {string} value
 * @param {Object} [options]
 * @param {number} [options.days] Lifetime in days (persistent when set, session otherwise)
 * @param {string} [options.sameSite='Lax']
 * @param {boolean} [options.secure=true]
 */
export const setCookie = (name, value, { days, sameSite = 'Lax', secure = true } = {}) => {
  if (typeof document === 'undefined') return;

  let cookie = `${name}=${value}; Path=/; SameSite=${sameSite}`;
  if (days) cookie += `; Max-Age=${days * 24 * 60 * 60}`;
  if (secure) cookie += '; Secure';

  document.cookie = cookie;
};

/**
 * Clear a host cookie previously written with Path=/.
 * @param {string} name
 */
export const removeCookie = (name) => {
  if (typeof document === 'undefined') return;

  document.cookie = `${name}=; Path=/; Max-Age=0`;
};
